import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconGlossary = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 13 13",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 2.438C0 1.54.729.812 1.625.812h9.75c.896 0 1.625.73 1.625 1.625v8.126c0 .896-.729 1.624-1.625 1.624h-9.75A1.626 1.626 0 0 1 0 10.563V2.437Zm6.5 0v8.124h4.875V2.438H6.5Z"
	})
});
export default SvgIconGlossary;
